module.exports = __webpack_public_path__ + "static/img/aruxpay_logo.70f9f496.png";